// Volume Trend Report Action Types
export const VOLUME_TREND_REQUEST = 'VOLUME_TREND_REQUEST';
export const VOLUME_TREND_SUCCESS = 'VOLUME_TREND_SUCCESS';
export const VOLUME_TREND_FAILURE = 'VOLUME_TREND_FAILURE';

//Pivot Volume Trend By ID

export const PIVOT_VOLUME_TREND_BY_ID_REQUEST = 'PIVOT_VOLUME_TREND_BY_ID_REQUEST';
export const PIVOT_VOLUME_TREND_BY_ID_SUCCESS = 'PIVOT_VOLUME_TREND_BY_ID_SUCCESS';
export const PIVOT_VOLUME_TREND_BY_ID_FAILURE = 'PIVOT_VOLUME_TREND_BY_ID_FAILURE';

//Unread Pivot Volume Trend By ID

export const UNREAD_PIVOT_VOLUME_TREND_BY_ID_REQUEST = 'UNREAD_PIVOT_VOLUME_TREND_BY_ID_REQUEST';
export const UNREAD_PIVOT_VOLUME_TREND_BY_ID_SUCCESS = 'UNREAD_PIVOT_VOLUME_TREND_BY_ID_SUCCESS';
export const UNREAD_PIVOT_VOLUME_TREND_BY_ID_FAILURE = 'UNREAD_PIVOT_VOLUME_TREND_BY_ID_FAILURE';

//UnreadPivot Volume Trend By ID SIte

export const UNREAD_PIVOT_VOLUME_TREND_BY_ID_SITE_REQUEST = 'UNREAD_PIVOT_VOLUME_TREND_BY_ID_SITE_REQUEST';
export const UNREAD_PIVOT_VOLUME_TREND_BY_ID_SITE_SUCCESS = 'UNREAD_PIVOT_VOLUME_TREND_BY_ID_SITE_SUCCESS';
export const UNREAD_PIVOT_VOLUME_TREND_BY_ID_SITE_FAILURE = 'UNREAD_PIVOT_VOLUME_TREND_BY_ID_SITE_FAILURE';
export const UNREAD_PIVOT_VOLUME_TREND_BY_ID_SITE_PRIORITY_REQUEST = 'UNREAD_PIVOT_VOLUME_TREND_BY_ID_SITE_PRIORITY_REQUEST';
export const UNREAD_PIVOT_VOLUME_TREND_BY_ID_SITE_PRIORITY_SUCCESS = 'UNREAD_PIVOT_VOLUME_TREND_BY_ID_SITE_PRIORITY_SUCCESS';
export const UNREAD_PIVOT_VOLUME_TREND_BY_ID_SITE_PRIORITY_FAILURE = 'UNREAD_PIVOT_VOLUME_TREND_BY_ID_SITE_PRIORITY_FAILURE';


// RollOver ExamData Volume Trend

export const ROLLOVER_EXAMDATA_VOLUME_TREND_REQUEST = 'ROLLOVER_EXAMDATA_VOLUME_TREND_REQUEST';
export const ROLLOVER_EXAMDATA_VOLUME_TREND_SUCCESS = 'ROLLOVER_EXAMDATA_VOLUME_TREND_SUCCESS';
export const ROLLOVER_EXAMDATA_VOLUME_TREND_FAILURE = 'ROLLOVER_EXAMDATA_VOLUME_TREND_FAILURE';

//Delete Scheduling ForeCastReport

export const DELETE_SCHEDULING_FORECAST_REPORT_REQUEST = 'DELETE_SCHEDULING_FORECAST_REPORT_REQUEST';
export const DELETE_SCHEDULING_FORECAST_REPORT_SUCCESS = 'DELETE_SCHEDULING_FORECAST_REPORT_SUCCESS';
export const DELETE_SCHEDULING_FORECAST_REPORT_FAILURE = 'DELETE_SCHEDULING_FORECAST_REPORT_FAILURE';

//Get Volume Trend ReportsBy ID

export const GET_VOLUME_TREND_REPORTS_BY_ID_REQUEST = 'GET_VOLUME_TREND_REPORTS_BY_ID_REQUEST';
export const GET_VOLUME_TREND_REPORTS_BY_ID_SUCCESS = 'GET_VOLUME_TREND_REPORTS_BY_ID_SUCCESS';
export const GET_VOLUME_TREND_REPORTS_BY_ID_FAILURE = 'GET_VOLUME_TREND_REPORTS_BY_ID_FAILURE';
export const GET_VOLUME_TREND_SCHEDULING_FORECAST_BY_ID_REQUEST = 'GET_VOLUME_TREND_SCHEDULING_FORECAST_BY_ID_REQUEST';
export const GET_VOLUME_TREND_SCHEDULING_FORECAST_BY_ID_SUCCESS = 'GET_VOLUME_TREND_SCHEDULING_FORECAST_BY_ID_SUCCESS';
export const GET_VOLUME_TREND_SCHEDULING_FORECAST_BY_ID_FAILURE = 'GET_VOLUME_TREND_SCHEDULING_FORECAST_BY_ID_FAILURE';

// Save Volumn Trend Report

export const SAVE_VOLUME_TREND_REPORT_REQUEST = 'SAVE_VOLUME_TREND_REPORT_REQUEST';
export const SAVE_VOLUME_TREND_REPORT_SUCCESS = 'SAVE_VOLUME_TREND_REPORT_SUCCESS';
export const SAVE_VOLUME_TREND_REPORT_FAILURE = 'SAVE_VOLUME_TREND_REPORT_FAILURE';

// Draft Save Volume Trend Report

export const DRAFT_SAVE_VOLUME_TREND_REPORT_REQUEST = 'DRAFT_SAVE_VOLUME_TREND_REPORT_REQUEST';
export const DRAFT_SAVE_VOLUME_TREND_REPORT_SUCCESS = 'DRAFT_SAVE_VOLUME_TREND_REPORT_SUCCESS';
export const DRAFT_SAVE_VOLUME_TREND_REPORT_FAILURE = 'DRAFT_SAVE_VOLUME_TREND_REPORT_FAILURE';

// Publish Volume Trend Report

export const PUBLISH_VOLUME_TREND_REPORT_REQUEST = 'PUBLISH_VOLUME_TREND_REPORT_REQUEST';
export const PUBLISH_VOLUME_TREND_REPORT_SUCCESS = 'PUBLISH_VOLUME_TREND_REPORT_SUCCESS';
export const PUBLISH_VOLUME_TREND_REPORT_FAILURE = 'PUBLISH_VOLUME_TREND_REPORT_FAILURE';

//Export Volume Trend Report

export const EXPORT_VOLUME_TREND_REPORT_REQUEST = 'EXPORT_VOLUME_TREND_REPORT_REQUEST';
export const EXPORT_VOLUME_TREND_REPORT_SUCCESS = 'EXPORT_VOLUME_TREND_REPORT_SUCCESS';
export const EXPORT_VOLUME_TREND_REPORT_FAILURE = 'EXPORT_VOLUME_TREND_REPORT_FAILURE';

// Report Note

export const REPORT_NOTE_REQUEST = 'REPORT_NOTE_REQUEST';
export const REPORT_NOTE_SUCCESS = 'REPORT_NOTE_SUCCESS';
export const REPORT_NOTE_FAILURE = 'REPORT_NOTE_FAILURE';

// Save Notes

export const SAVE_REPORT_NOTE_REQUEST = 'SAVE_REPORT_NOTE_REQUEST';
export const SAVE_REPORT_NOTE_SUCCESS = 'SAVE_REPORT_NOTE_SUCCESS';
export const SAVE_REPORT_NOTE_FAILURE = 'SAVE_REPORT_NOTE_FAILURE';

// Reset Rollover ExamData

export const RESET_ROLLOVER_EXAMDATA = 'RESET_ROLLOVER_EXAMDATA';

// Get Exam Data Volume Trend (for Roll Over Demand)

export const GET_EXAM_DATA_VOLUME_TREND_REQUEST = 'GET_EXAM_DATA_VOLUME_TREND_REQUEST';
export const GET_EXAM_DATA_VOLUME_TREND_SUCCESS = 'GET_EXAM_DATA_VOLUME_TREND_SUCCESS';
export const GET_EXAM_DATA_VOLUME_TREND_FAILURE = 'GET_EXAM_DATA_VOLUME_TREND_FAILURE';

// Get Volume Trend Dropdowns
export const GET_VOLUME_TREND_DROPDOWNS_REQUEST = 'GET_VOLUME_TREND_DROPDOWNS_REQUEST';
export const GET_VOLUME_TREND_DROPDOWNS_SUCCESS = 'GET_VOLUME_TREND_DROPDOWNS_SUCCESS';
export const GET_VOLUME_TREND_DROPDOWNS_FAILURE = 'GET_VOLUME_TREND_DROPDOWNS_FAILURE';